import React, { FC, Fragment, useEffect, useMemo } from "react";
import { makeStyles } from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import clsx from "clsx";
import { Route, Switch, useHistory, useLocation } from "react-router";
import { AdapterLink } from "../../../../../components/Adopter";
import Error from "../../../../../components/Error";
import ScrollTop from "../../../../../components/ScrollToTop";
import { ManagedStudentAccountPage } from "../../../../student/pages/ManagedStudentAccountPage";
import { ManagedStudentsPage } from "../../../../student/pages/ManagedStudentsPage";
import { useUserAccount } from "../../context";
import { UserRole } from "../../../enums/UserRole";

const useStyles = makeStyles(() => ({
  tabs: {
    marginTop: 24,
    marginBottom: 14,
  },
  tabLink: {
    "&:hover": {
      textDecoration: "none",
    },
  },
  root: {
    minWidth: 0,
    padding: "6px 16px",
  },
}));

const Agent: FC = () => {
  const classes = useStyles();

  const { userIsAuthUser, path } = useUserAccount();
  const history = useHistory();
  const { pathname } = useLocation();
  const pieces = pathname.split(`${path}`);
  const tabRoute = pieces[pieces.length - 1]
    .replace(/^\/|\/$/g, "")
    .split("/")[0];
  const currentRoute = "/0/user/:userId/edit";

  useEffect(() => {
    if (tabRoute === "") {
      history.replace({
        pathname: pathname + "/student",
      });
    }
  }, []);

  const tabs = useMemo(() => {
    let list: any[] = [
      {
        label: "Students",
        component: () => <ManagedStudentsPage userRole={UserRole.Agent} />,
        path: "/student",
        children: [
          {
            component: ManagedStudentAccountPage,
            path: "/:studentId",
          },
        ],
      },
    ];

    return list;
  }, [userIsAuthUser]);

  if (!tabRoute || !tabs.length) return null;

  return (
    <>
      <Tabs value={tabRoute} variant="scrollable" className={classes.tabs}>
        {tabs.map((item, index) => (
          <Tab
            component={AdapterLink}
            className={clsx(classes.tabLink, classes.root)}
            key={index}
            label={item.label}
            value={item.path.replace(/^\/|\/$/g, "")}
            to={path + item.path}
          />
        ))}
      </Tabs>
      <Switch>
        {tabs.map((item, index) => (
          <Fragment key={index}>
            <Route
              exact
              path={currentRoute + item.path}
              component={item.component}
            />
            {item.children?.map((subItem, subIndex) => (
              <Route
                key={subIndex}
                path={currentRoute + item.path + subItem.path}
                component={subItem.component}
              />
            ))}
          </Fragment>
        ))}
        <Route
          path={`${currentRoute}/*`}
          component={() => <Error text={"Not found"} />}
        />
      </Switch>
      <ScrollTop threshold={200} />
    </>
  );
};

export default Agent;
